import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getProformaList = (page, pagesize, search, groupId, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/proforma/', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getWorkOrderDropdown = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/get-pending-workorders', {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        },
    });
};


const getArchiveProformaList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/proforma/archive-list', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getProformaById = ({ id }) => {
    return axios.get( `${API_URL}/api/${API_VERSION}/proforma/${id}/`, {
        headers: authHeader()
    });
};
const addProforma = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/proforma/`,
        formData, // Payload for the request body
        { headers: authHeader() }
    );
};
const updateProforma = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/proforma/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }
    );
};
const archiveProforma = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/proforma/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveProforma = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/proforma/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const proformaService = {
    getProformaList,
    getArchiveProformaList,
    getProformaById,
    addProforma,
    getWorkOrderDropdown,
    updateProforma,
    archiveProforma,
    unArchiveProforma
};

export default proformaService;
